import { useEffect } from "react";

type Props = {
  hasUnsavedChanges: boolean;
  onNavigateAttempt: (href: string) => void;
};

export const useUnsavedChangesDialog = ({
  hasUnsavedChanges,
  onNavigateAttempt,
}: Props) => {
  useEffect(() => {
    const links = document.querySelectorAll<HTMLAnchorElement>("a");

    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const link = target.closest<HTMLAnchorElement>("a");
      if (!link) return;

      if (hasUnsavedChanges) {
        event.preventDefault();
        onNavigateAttempt(link.getAttribute("href") || "");
      }
    };

    links.forEach((link) => {
      link.addEventListener("click", handleClick);
    });

    return () => {
      links.forEach((link) => {
        link.removeEventListener("click", handleClick);
      });
    };
  }, [hasUnsavedChanges, onNavigateAttempt]);
};
